<template>
    <v-app-bar clipped-left app dark dense color="primary" >
      <v-btn icon="mdi-menu" @click="toggleSidebar"><v-icon>mdi-menu</v-icon></v-btn>
        <v-toolbar-title style="width: 300px; cursor: pointer" class="headline text-uppercase" @click="goHome">
            <span class="font-weight-black">XMAP</span>
            <span class="font-weight-light">Assess</span>
            <span class="font-weight-thin caption ml-2">{{versionNum}}</span>
        </v-toolbar-title>
        <v-btn depressed color="primary" class="ml-2" @click="handleCreate">Create</v-btn>
        <v-btn depressed color="primary" class="ml-2" to="/find">Marking</v-btn>
        <v-btn depressed
               v-if="userType === 'admin'"
               color="primary" class="ml-2" to="/reports">Reports</v-btn>
        <v-spacer></v-spacer>
        <v-menu>
            <template v-slot:activator="{ on }">
                <v-btn depressed
                       color="primary"
                       dark
                       v-on="on">
                    <v-icon>mdi-settings</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item-content>
                    <v-list-item @click="goToQuestionmark">
                        <v-list-item-title>Go To QuestionMark</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logOut">
                        <v-list-item-title>Log Out</v-list-item-title>
                    </v-list-item>
                </v-list-item-content>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
  import {auth} from 'firebase'

  export default {
    name: "theToolbar",

    computed: {
      versionNum () {
        return process.env.VUE_APP__VERSION_NUMBER_
      },
      userType () {
        return this.$store.getters['USER_TYPE']
      }
    },

    methods: {
      handleCreate() {
        this.$store.commit('RESET_TEMP_QUESTION');
        this.$router.push({
          name: 'create'
        })
      },
      goHome() {
        this.$router.push({
          name: 'home'
        })
      },
      goToQuestionmark() {
        this.$router.push({
          name: 'questionmark'
        })
      },
      logOut() {
        auth().signOut();
      },
      toggleSidebar(){
        this.$store.commit('TOGGLE_SIDEBAR')
      }
    },

    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
